import React from 'react';

interface CellProps {
  children: React.ReactNode;
  center?: boolean;
  mono?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLTableCellElement>;
  noBorder?: boolean;
}

export function Cell({
  children,
  center,
  mono,
  className = '',
  style,
  onClick,
  noBorder,
}: CellProps) {
  return (
    <td
      onClick={onClick}
      style={style}
      className={`px-4 py-2 ${noBorder ? '' : 'border-b border-gray-100'}
        ${center ? 'text-center' : 'text-left'}
        ${mono ? 'font-mono' : ''}
        ${className}`}
    >
      {children}
    </td>
  );
}
